// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import axios from 'axios'
import qs from 'qs.js'
import vueHeadful from 'vue-headful';
import i18n from './tools/i18n'

// import request from './service/request'

import { Button, Select, Carousel ,CarouselItem , Row, Loading} from 'element-ui';

Vue.config.productionTip = false
Vue.use(VueResource);

//loading
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

// Vue.prototype.$http = request    //全局注册，使用方法为:this.$http
axios.defaults.baseURL = 'http://m2-staging.ehsy.com'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$http
Vue.prototype.qs = qs
let protocol = window.location.protocol
Vue.http.options.root = protocol+'//m2.ehsy.com';

Vue.component('vue-headful', vueHeadful);
// Vue.component(Button.name, Button);
// Vue.component(Select.name, Select);
// Vue.component(Carousel.name, Carousel);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
// Vue.component(Row.name, Row);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js